import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ClientRegistration from './ClientRegistration';
import TechnicianRegistration from './TechnicianRegistration';

export default function RegisterPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get('as') === 'client' ? 'client' : 'technician');

  return (
    <div className="page">
      <div className="auth-wrap wide">
        <div className="card pad">
          <h2 style={{ marginBottom: '1rem' }}>{t('auth.createAccount')}</h2>
          <div className="tabs">
            <button className={tab === 'client' ? 'active' : ''} onClick={() => setTab('client')}>
              {t('auth.iNeedTechnician')}
            </button>
            <button className={tab === 'technician' ? 'active' : ''} onClick={() => setTab('technician')}>
              {t('auth.iAmTechnician')}
            </button>
          </div>
          {tab === 'client' ? <ClientRegistration /> : <TechnicianRegistration />}
          <p className="muted center" style={{ marginTop: '1rem', fontSize: '.9rem' }}>
            {t('auth.haveAccount')} <Link to="/login">{t('nav.login')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
